import { Paper, Typography } from '@material-ui/core';
import Authorize from 'components/Authorize';
import { permissionProfiles } from 'components/Authorize/permissionProfiles';
import { activityStatuses } from 'features/activity/activityConsts';
import WorkOrderCard from 'features/landing/components/FleetManagementDashboard/WorkorderApprovalWidget/WorkorderList/WorkOrderCard';
import { groupBy, orderBy } from 'lodash';
import { vehicleApprovalCardsStyle } from './VehicleApprovalCardsStyle';

const PENDING_STATUSES = new Set([
    activityStatuses.PendingClientApproval,
    activityStatuses.PendingClientDecision,
]);

const VehicleApprovalCards = ({ activityLogData, client }) => {
    const classes = vehicleApprovalCardsStyle();

    // Sort all activities newest-first, group by work order, keep only the
    // latest entry per work order, then filter to pending-approval statuses.
    const activities = orderBy(
        (activityLogData || []).filter(a => a.activityLogId),
        ['activityDate'],
        ['desc']
    );

    const grouped = groupBy(activities, 'workOrderId');

    const pendingActivities = Object.values(grouped)
        .map(entries => entries[0])
        .filter(a => PENDING_STATUSES.has(a.activityId))
        .map(a => ({ ...a, id: a.activityLogId, price: a.cost, clientName: client?.name }));

    if (!pendingActivities.length) return null;

    return (
        <Authorize profile={permissionProfiles.ACTIVITY.APPROVE_PENDING_CLIENT}>
            <Paper className={classes.card}>
                <Typography className={classes.title}>Pending Repair Approvals</Typography>
                {pendingActivities.map(activity => (
                    <WorkOrderCard
                        key={activity.activityLogId}
                        entity={activity}
                        handleDone={() => {}}
                    />
                ))}
            </Paper>
        </Authorize>
    );
};

export default VehicleApprovalCards;
